/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Tlm_0Inputs */

const en_svc_rag_knowledge_assistants_tlm_0 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`retrieval`)
};

const ar_svc_rag_knowledge_assistants_tlm_0 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاسترجاع`)
};

const bn_svc_rag_knowledge_assistants_tlm_0 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিট্রিভাল`)
};

const de_svc_rag_knowledge_assistants_tlm_0 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrieval`)
};

const es_svc_rag_knowledge_assistants_tlm_0 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperación`)
};

const fr_svc_rag_knowledge_assistants_tlm_0 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupération`)
};

const pt_svc_rag_knowledge_assistants_tlm_0 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recuperação`)
};

const zh_svc_rag_knowledge_assistants_tlm_0 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检索`)
};

const tr_svc_rag_knowledge_assistants_tlm_0 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getirme`)
};

const ru_svc_rag_knowledge_assistants_tlm_0 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск`)
};

const pl_svc_rag_knowledge_assistants_tlm_0 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyszukiwanie`)
};

/**
* | output |
* | --- |
* | "retrieval" |
*
* @param {Svc_Rag_Knowledge_Assistants_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_tlm_0 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_tlm_0(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_tlm_0(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_tlm_0(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_tlm_0(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_tlm_0(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_tlm_0(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_tlm_0(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_tlm_0(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_tlm_0(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_tlm_0(inputs)
	return en_svc_rag_knowledge_assistants_tlm_0(inputs)
});
export { svc_rag_knowledge_assistants_tlm_0 as "svc_rag-knowledge-assistants_tlm_0" }